import { render, staticRenderFns } from "./Changeprice.vue?vue&type=template&id=3c1eaadc&scoped=true&"
import script from "./Changeprice.vue?vue&type=script&lang=js&"
export * from "./Changeprice.vue?vue&type=script&lang=js&"
import style0 from "./Changeprice.vue?vue&type=style&index=0&id=3c1eaadc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1eaadc",
  null
  
)

export default component.exports